import type { SelectHTMLAttributes } from "react";

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
};

export function Select({ className = "", label, children, ...props }: SelectProps) {
  return (
    <label className={["select-field", className].filter(Boolean).join(" ")}>
      <span>{label}</span>
      <select {...props}>{children}</select>
    </label>
  );
}
